const e = {
  name: "OneTwoThree",
  dimensions: { width: 40, height: 18 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 18" style="enable-background:new 0 0 40 18;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,2H0V0h6v16h4v2H0v-2h4V2z"/>
		<path class="st0" d="M15,2h8v6h-8v10h10v-2h-8v-6h8V0H15V2z"/>
		<path class="st0" d="M38,2h-8V0h10v18H30v-2h8v-6h-8V8h8V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as OneTwoThree
};
